var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLogoutIconHover(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 17 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m6.316 7.3837c-0.34998 0-0.62672 0.27199-0.62672 0.61597 0 0.33599 0.27674 0.61598 0.62672 0.61598h4.8835v3.8238c0 1.9599-1.6197 3.5598-3.6219 3.5598h-3.9638c-1.9941 0-3.6138-1.5919-3.6138-3.5518v-8.8876c0-1.9679 1.6278-3.5598 3.622-3.5598h3.9719c1.986 0 3.6056 1.5919 3.6056 3.5519v3.8318h-4.8835zm7.7876-2.1518 2.3359 2.3279c0.12 0.11999 0.184 0.27199 0.184 0.43998 0 0.16-0.064 0.31999-0.184 0.43198l-2.3359 2.3279c-0.12 0.12-0.28 0.184-0.432 0.184-0.16 0-0.3199-0.064-0.4399-0.184-0.24-0.24-0.24-0.632 0-0.87197l1.2799-1.2719h-3.3119v-1.232h3.3119l-1.2799-1.272c-0.24-0.23999-0.24-0.63198 0-0.87197 0.2399-0.24799 0.6319-0.24799 0.8719-8e-3z",
    clipRule: "evenodd",
    fill: "#00649C",
    fillRule: "evenodd"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogoutIconHover);
export default __webpack_public_path__ + "static/media/logout-icon-hover.bc1b93968375789fd4c6f7b1ca1f44fc.svg";
export { ForwardRef as ReactComponent };